import { SearchFilterTag } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import {
  getAmountSearchTagLabel,
  resetAnalyticTrendFields,
} from '@/features/search/_utils/projects-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

type Props = {
  index: number;
};

export const AmountSearchTypeTag: FC<Props> = ({ index }) => {
  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({ control, name: 'sheetType' });
  const fiscalYear = useWatch({ control, name: 'fiscalYear' });
  const amountSearchConditions = useWatch({
    control,
    name: 'amountSearchConditions',
  });

  if (!amountSearchConditions || !amountSearchConditions[index]) {
    return null;
  }

  const condition = amountSearchConditions[index];

  const label = getAmountSearchTagLabel({
    amountSearchType: condition.amountSearchType,
    amountSearchBaseYearWithBudgetType:
      condition.amountSearchBaseYearWithBudgetType,
    amountSearchBaseYearWithBudgetTypeEnd:
      condition.amountSearchBaseYearWithBudgetTypeEnd,
    amountSearchDiffAmount: condition.amountSearchDiffAmount,
    amountSearchDiffAmountUnit: condition.amountSearchDiffAmountUnit,
    amountSearchDiffOperator: condition.amountSearchDiffOperator,
  });

  if (sheetType !== 'RS' || !fiscalYear || !label) {
    return null;
  }

  return (
    <SearchFilterTag
      closable={true}
      label={label}
      onClose={() => {
        resetAnalyticTrendFields(setValue, index);
      }}
    />
  );
};
